/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { Route, Redirect } from 'react-router-dom'

/**
 *     Import
 *     - Components
 */
import Container from '../../common/Container/Container'
import HeaderContainer from '../../common/HeaderContainer/HeaderContainer'
import StepCounter from '../../common/StepCounter/StepCounter'
import PopUp from '../../common/PopUp/PopUp'
import Loading from '../../common/Loading/Loading'

/**
 *     Import
 *     - Pages
 */
import Step00Form from '../../../containers/pages/Quote/Step00'
import Step01Form from '../../../containers/pages/Quote/Step01'
import Step02 from '../../../containers/pages/Quote/Step02'
import Step02cp from '../../../containers/pages/Quote/Step02cp'
import Step03Form from '../../../containers/pages/Quote/Step03'
import Step04Form from '../../../containers/pages/Quote/Step04'
import Step05 from '../../../containers/pages/Quote/Step05'
import Summary from '../../../containers/pages/Quote/Summary'

import Step03cForm from '../../../containers/pages/Quote/Step03c'
import Step03mForm from '../../../containers/pages/Quote/Step03m'
import Step03dForm from '../../../containers/pages/Quote/Step03d'
import Step03wForm from '../../../containers/pages/Quote/Step03w'
import Step04cForm from '../../../containers/pages/Quote/Step04c'
import Step04wForm from '../../../containers/pages/Quote/Step04w'
import Step04mForm from '../../../containers/pages/Quote/Step04m'
import Step04dForm from '../../../containers/pages/Quote/Step04d'
import Step05c from '../../../containers/pages/Quote/Step05c'
import Step05m from '../../../containers/pages/Quote/Step05m'
import Step05d from '../../../containers/pages/Quote/Step05d'
import Step05cp from '../../../containers/pages/Quote/Step05cp'

/**
 *     Import
 *     - CSS
 */
import './styles/Quote.css'

export default class Quote extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
    }

    componentWillMount() {
        this.props.changeNavState(1)
        this.props.checkQuoteStep(this.props.match.params.quoteId)
        if (this.props.match.params.quoteId === 'new') {
            this.props.resetStep()
        } else {
            this.props.getFullQuote(this.props.match.params.quoteId)
        }
    }

    componentWillUpdate(nextProps: any) {
        if ((this.props.match.params.quoteId !== nextProps.match.params.quoteId)
            || (this.props.match.params.step !== nextProps.match.params.step)) {
            this.props.getFullQuote(this.props.match.params.quoteId)
            this.props.checkQuoteStep(nextProps.match.params.quoteId)
        }
    }

    componentWillUnmount() {
        this.props.changeNavState(null)
    }

    getActiveStepIndex(step: any) {
        switch (step) {
            case 'step00': return 0
            case 'step01': return 1
            case 'step02': return 2
            case 'step03': return 3
            case 'step04': return 4
            case 'step05': return 5
            case 'step06': return 6
            case 'summary': return 6
            default: return 1
        }
    }

    /**
     * Generates the message to show in the Error PopUp
     *
     * @param {*} errors the errors received from the server
     * @returns {String} the whole message to show in the PopUp
     * @memberof Quote
     */
    getErrorMessages(errors: any) {
        let returningMessage = ''
        for (var key in errors) {
            if (errors.hasOwnProperty(key) && key !== 'sanctionChecker') {
                var obj = errors[key]
                for (var prop in obj) {
                    if (obj.hasOwnProperty(prop)) {
                        returningMessage += key + ' ' + obj[prop] + '\n'
                    }
                }
            }
        }

        return returningMessage
    }

    /**
     * Closes the error PopUp
     *
     * @memberof Quote
     */
    closeErrorPopUp = () => {
        this.props.quote.step00.error = null
        this.forceUpdate()
    }

    render() {
        const {
            quote,
            isCommercialProperty = false,
        } = this.props

        if (this.props.quote.checkStep.loading) {
            return (
                <Container className="quote__form" fullwidth={false}>
                    <Loading />
                </Container>
            )
        }

        const { quoteId, step } = this.props.match.params

        let response = {
            status: true,
            // step: 'step01',
            step: isCommercialProperty ? `step0${[3, 4].includes(this.props.quoteStep) ? '5' : this.props.quoteStep}` :
                `step0${this.props.quoteStep}`,
        }

        const titles = quote.checkStep.response.isCollectors ? [
            'Client Details',
            'Policy Details',
            'Risk Address',
            'Add Collection Assets',
            'Collections Locations',
            'Policy Preview',
            'Quote Bound',
        ] : quote.checkStep.response.isMuseums ? [
            'Client Details',
            'Policy Details',
            'Risk Address',
            'Add Museums Assets',
            'Museums Locations',
            'Policy Preview',
            'Quote Bound',
        ] : quote.checkStep.response.isDealersStock ? [
            'Client Details',
            'Policy Details',
            'Risk Address',
            'Add Dealer Stock Assets',
            'Dealers Stock Locations',
            'Policy Preview',
            'Quote Bound',
        ] : quote.checkStep.response.isWineSpirits ? [
            'Client Details',
            'Policy Details',
            'Risk Address',
            'Add Wine & Spirits Assets',
            'Wine & Spirits Locations',
            'Policy Preview',
            'Quote Bound',
        ] : quote.checkStep.response.isCommericalProperty ? [
            'Client Details',
            'Policy Details',
            'Risk Address',
            'Policy Preview',
            'Quote Bound',
        ] : [
            'Client Details',
            'Policy Details',
            'Risk Address',
            'Add Stock & Business Assets',
            'Additional Cover',
            'Policy Preview',
            'Quote Bound',
        ]

        if (quoteId === undefined || quoteId === '') {
            // tslint:disable-next-line
            console.log('quoteId empty')
            return (<Redirect to={`/quote/new/step00`} />)
        } else {

            // Check if this is a new quote
            // If not, check the id on the server
            if (quoteId !== 'new') {
                // Check this ID on the server
                // {CODE FOR FECTH API WITH quoteId}

                // If server response is
                // that ID is not valid or do not exist
                // push the page for a new quote
                if (response.status === false) {
                    // tslint:disable-next-line
                    console.log('THIS ID IS NOT VALID')
                    return (<Redirect to={`/quote/new/step00`} />)
                } else {
                    // tslint:disable-next-line
                    // console.log('THIS ID IS VALID. Go to ' + response.step)
                    // console.log('The next step is ' + this.props.quoteStep)
                    // console.log('The next step is ' + step)
                    if ((step === 'step01' || step === 'step02' || step === 'step03' || step === 'step04')
                        && (this.props.isCollectors || this.props.isWineSpirits)) {
                        // console.log('Collector Form')
                    } else if (step === undefined || step === '') {
                        return (<Redirect to={`/quote/${quoteId}/${response.step}`} />)
                    } else if (step.substr((step.length - 1)) < this.props.quote.step) {
                        // console.log(this.props.quote.step)
                        return (<Redirect to={`/quote/${quoteId}/${response.step}`} />)
                    }
                }

            } else {
                if (step === undefined || step === '' || step !== 'step00') {
                    return (<Redirect to={`/quote/${quoteId}/step0${this.props.quote.step}`} />)
                }
            }
        }

        let headerPreTitle = ''
        if (quote.checkStep.done) {
            headerPreTitle = quote.checkStep.response.isCollectors
                ? 'Collections Policy'
                : quote.checkStep.response.isMuseums ? 'Museums Policy' : quote.checkStep.response.isDealersStock ?
                    'Dealers Stock' : quote.checkStep.response.isWineSpirits ?
                        'Wine & Spirits' : quote.checkStep.response.isCommercialProperty ? 'Commercial Property' :
                            'Commercial Art Insurance'
        }

        return (
            <div className="quote">

                {(this.props.quote.step00.error &&
                    !this.props.quote.step00.error.errors.sanctionChecker) ?
                    <PopUp
                        title="There are errors"
                        action={this.closeErrorPopUp}
                        buttonText="Accept"
                    >
                        {this.getErrorMessages(this.props.quote.step00.error.errors)}
                    </PopUp>
                    : null}

                {(this.props.quote.step00.error &&
                    this.props.quote.step00.error.errors.sanctionChecker) ?
                    <PopUp
                        title="Referral"
                        action={() => { this.props.history.push(`/dashboard`) }}
                        buttonText="Go back to dashboard"
                    >
                        <h4>The client has failed the sanctions check</h4>
                    </PopUp>
                    : null}

                <HeaderContainer
                    className="quote__header"
                    pretitle={step !== 'step00' ? headerPreTitle : ''}
                    titles={[titles[this.getActiveStepIndex(step)]]}
                >
                    <StepCounter step={step} stepIndex={this.getActiveStepIndex(step)} />
                </HeaderContainer>

                <Container className="quote__form container__wider" fullwidth={false}>
                    <Route exact={true} path="/quote/:quoteId/step00" component={Step00Form} />
                    <Route exact={true} path="/quote/:id/step01" component={Step01Form} />
                    <Route
                        exact={true}
                        path="/quote/:id/step02"
                        component={quote.checkStep.response.isCommercialProperty ? Step02cp : Step02}
                    />
                    <Route
                        exact={true}
                        path="/quote/:id/step03"
                        component={quote.checkStep.response.isCollectors ? Step03cForm :
                            quote.checkStep.response.isMuseums ? Step03mForm :
                                quote.checkStep.response.isDealersStock ? Step03dForm :
                                    quote.checkStep.response.isWineSpirits ? Step03wForm : Step03Form}
                    />
                    <Route
                        exact={true}
                        path="/quote/:id/step04"
                        component={quote.checkStep.response.isCollectors ? Step04cForm :
                            quote.checkStep.response.isMuseums ? Step04mForm :
                                quote.checkStep.response.isDealersStock ? Step04dForm :
                                    quote.checkStep.response.isWineSpirits ? Step04wForm : Step04Form}
                    />
                    <Route
                        exact={true}
                        path="/quote/:id/step05"
                        component={(quote.checkStep.response.isCollectors || quote.checkStep.response.isWineSpirits) ?
                            Step05c : quote.checkStep.response.isMuseums ? Step05m :
                                quote.checkStep.response.isDealersStock ? Step05d :
                                    quote.checkStep.response.isCommercialProperty ? Step05cp : Step05}
                    />
                    <Route exact={true} path="/quote/:id/step06" component={Summary} />
                    <Route exact={true} path="/quote/:quoteId/summary" component={Summary} />
                </Container>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Quote.tsx